import { create } from 'zustand'
import { DateTime } from 'luxon'

let ephemeralStore = null

export const createEphemeralStore = () => {
  if (ephemeralStore) return ephemeralStore

  ephemeralStore = create((set, get) => ({
    dateNow: null,
    isSimulatedProgress: false,
    userStateCopy: null,

    /**
     *
     * @param {*} dateNow<Date>
     */
    updateDateNow: async dateNow => {
      const dateNowFinal = dateNow
        ? dateNow.startOf('day').plus({ seconds: 1 })
        : DateTime.now().startOf('day').plus({ seconds: 1 })

      set({ dateNow: dateNowFinal })
    },
    enableSimulatedProgress: () => {
      set({ isSimulatedProgress: true })
    },
    disableSimulatedProgress: () => {
      set({ isSimulatedProgress: false })
    },
    setUserStateCopy: userStateCopy => {
      set({ userStateCopy })
    },

    resetStore: async () => {
      set({ dateNow: null, isSimulatedProgress: false, userStateCopy: null })
    },
  }))

  return ephemeralStore
}

export default createEphemeralStore
